import user from "@/store/modules/user";
import paramConfig from "@/store/modules/paramConfig";
import supplier from "@/store/modules/supplier";

const getters = {
    USER_INFO: (state: any) => state.user.userInfo,
    PARAM_CONFIG: (state: any) => state.paramConfig.paramConfig,
    ROLE_INFO: (state: any) => state.role.roleInfo,
    SUPPLIER_INFO: (state: any) => state.supplier.info,
    NXTELE_INFO: (state: any) => state.nxtele.info,
    addRouters: (state: any) => state.permission.addRouters,
    routers: (state: any) => state.permission.routers
}

export default getters
